export default __webpack_public_path__ + "static/media/DiagramPreview.aaa179b7.mp4";